import React, { Fragment } from 'react'
import { CardBody, Header, Main } from './styles'
import { staticAssetsPath } from '../../configs/constants'
import { useSasToken } from '../../_hooks/useSasToken'

interface SupportTicketProps {
  refId: string
}
const SupportTicket: React.FC<SupportTicketProps> = ({ refId }: SupportTicketProps) => {
  const { displayName: name } = JSON.parse(localStorage.getItem('userInfoData') || '')
  const { appendToken } = useSasToken()

  return (
    <Fragment>
      <Main>
        <div className="ms-3 pt-5">
          <Header>Stay strong {name?.split(',')[1]},</Header>
          <Header className="mb-2">Help is on the way.</Header>
        </div>
        <CardBody className="mx-2 p-2">
          <img src={appendToken(`${staticAssetsPath}/images/pages/support.gif`)} alt="help" />
          <h5 className="mt-1">Ticket created successfully : </h5>
          <h4 className="text-bold">{refId}</h4>
          <br />
          <h5>We have received your message and would like to thank you for writing to us.</h5>
          <br />
          <h5>We will reply by email as soon as possible.</h5>
          <br />
          <h5>Talk to you soon!</h5>
        </CardBody>
      </Main>
    </Fragment>
  )
}

export default SupportTicket
